import { directiveSettings } from '../../utils/parse';
import { putData, getData } from '../../utils/data';
import Toggler from '../../utils/toggler';
/**
 * @module directives/action/toggler
 */

/**
 * Toggles the visual display of an element on the page.
 * Contains action directives for interacting with a toggler element:
 *  - toggler-open
 *  - toggler-close
 *  - toggler-toggle
 *  - toggler-select
 *  - toggler-class
 */
export default function togglerDirective() {

  // Create togglers
  document.querySelectorAll('[data-sw-toggler]').forEach(element => {
    const data = element.getAttribute('data-sw-toggler'),
    settings = directiveSettings(data, {
      open: true,
      transition: false,
    }, 'open');
    putData(element, 'toggler', new Toggler(element, settings));
  });

  /**
   * Action togglers.
   */
  for (let action of ['open', 'close', 'toggle']) {
    document.querySelectorAll(`[data-sw-toggler-${action}]`).forEach(element => {

      const data = element.getAttribute(`data-sw-toggler-${action}`),
      settings = directiveSettings(data, {
        target: null,
        on: 'click',
        prevent: true,
      }, 'target');

      element.addEventListener(settings.on, event => {
        if (settings.prevent) event.preventDefault();
        const target = settings.target ? document.querySelector(settings.target) : element.closest('[data-sw-toggler]'),
        toggler = getData(target, 'toggler');
        if (toggler) toggler[action]();
      });
    });
  }

  /**
   * Controls togglers with a <select> field
   * Should be used with the [data-sw-selector] directive for best usability
   */
  document.querySelectorAll('select[data-sw-toggler-select]').forEach(element => {

    const values = element.querySelector('option').map(el => el.value),
    togglers = values.map(selector => {
      return getData(element.querySelector(selector), 'toggler');
    });

    togglers.forEach(toggler => {
      if (toggler) {
        const value = values[togglers.indexOf(toggler)] || null;
        if (value) toggler.on('open', _ => element.value = value);
      }
    });

    element.addEventListener('change', _ => togglers[values.indexOf(element.value)].open());
  });

  /**
   * Class togglers.
   */
  document.querySelectorAll('[data-sw-toggler-class]').forEach(element => {

    const data = element.getAttribute('data-sw-toggler-class'),
    settings = directiveSettings(data, {
      target: null,
      openClass: 'is-open',
      closedClass: 'is-closed',
    }, 'target');

    const target = settings.target ? document.querySelector(settings.target) : element.closest('[data-sw-toggler]'),
    toggler = getData(target, 'toggler');

    if (toggler) {
      const updateClasses = _ => {
        element.classList.remove(toggler.isOpen ? settings.closedClass : settings.openClass);
        element.classList.add(toggler.isOpen ? settings.openClass : settings.closedClass);
      };
      toggler.on('toggle', updateClasses);
      updateClasses();
    }
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/action/toggler.js